import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-verify-code',
  templateUrl: './auth-verify-code.component.html',
  styleUrls: ['./auth-verify-code.component.scss']
})
export class AuthVerifyCodeComponent {

}
